<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-9">
        <h2>User Management</h2>
        <p>You can search and manage users here.</p>
      </div>
      <div
           id="event_control"
           class="col-xs-3">
        <div class="row">
          <button
                  class="btn btn-md btn-primary d-block pull-right"
                  data-toggle="modal"
                  data-target="#addUserModal">
            <strong>Add User</strong>
          </button>
        </div>
      </div>
    </div>
    <div class="wrapper wrapper-content">
      <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Search User</h5>
              <div class="ibox-tools">
                <a class="collapse-link">
                  <i class="fa fa-chevron-up" />
                </a>
              </div>
            </div>
            <div class="ibox-content">
              <div class="ibox-content">
                <div class="row m-b-xs">
                  <div class="col-md-7">
                    <div class="form-inline">
                      <div class="form-group m-r-md">
                        <input
                               v-model="searchInputName"
                               type="text"
                               placeholder="Name"
                               class="form-control">
                      </div>
                      <div class="form-group">
                        <input
                               v-model="searchInputId"
                               type="text"
                               placeholder="School/Work ID"
                               class="form-control">
                      </div>
                      <div class="checkbox m-l-md m-r-md">
                        <input
                               id="searchIsAdmin"
                               v-model="searchIsAdmin"
                               type="checkbox">
                        <label for="searchIsAdmin">
                          Admin
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <button
                            class="btn btn-primary"
                            style="width:100%"
                            @click="searchSignedUser()">Search</button>
                  </div>
                  <div class="col-md-2">
                    <button
                            class="btn btn-primary m-l-md"
                            style="width:100%"
                            @click="searchReset()">Reset</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <p>You don’t need to fill in all boxes.</p>
                  </div>
                </div>
                <div
                     v-if="searchResultShow"
                     class="row animated fadeInDown">
                  <div class="col-ld-12">
                    <vuetable
                              ref="vuetable"
                              :fields="fields"
                              :data="searchResult.data"
                              :css="tablecss"
                              :api-mode="false"
                              @vuetable:cell-clicked="onCellClicked" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>User List</h5>
              <div class="ibox-tools">
                <button
                        class="btn btn-primary btn-xs"
                        @click="downloadUserList">Download as Excel</button>
              </div>
            </div>

            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                           class="m-r-sm"
                           style="max-width:20%;">Sort By</label>
                    <select
                            v-model="sortType"
                            class="form-control"
                            style="max-width:80%;display: inline-flex;">
                      <option value="0">Name A-Z</option>
                      <option value="1">Name Z-A</option>
                      <option value="2">ID 0-9</option>
                      <option value="3">ID 9-0</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label
                           class="m-r-sm"
                           style="max-width:50%;">Item per page</label>
                    <select
                            v-model="perPageInput"
                            class="form-control"
                            style="max-width:50%;display: inline-flex;">
                      <option value="1">1</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3">
                  <vuetable-pagination
                                       ref="pagination"
                                       :css="paginationcss"
                                       @vuetable-pagination:change-page="onChangePage" />
                </div>
              </div>
              <vuetable
                        ref="vuetable"
                        :fields="fields"
                        :data="formatUsersInfo"
                        :css="tablecss"
                        :api-mode="false"
                        pagination-path="pagination"
                        @vuetable:cell-clicked="onCellClicked" />
              <div class="vuetable-pagination">
                <vuetable-pagination-info ref="paginationInfo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
         id="addUserModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="addUserLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add User</h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form role="form">
              <div class="form-group">
                <label>Name</label>
                <input
                       v-model="addUserName"
                       type="name"
                       placeholder="Enter student name"
                       class="form-control">
              </div>
              <div class="form-group">
                <label>Student/Work ID</label>
                <input
                       v-model="addUserLdapId"
                       type="text"
                       placeholder="Enter student/work id"
                       class="form-control">
              </div>
              <div class="form-group">
                <label for="addUserType">User Type</label>
                <select
                        id="addUserType"
                        v-model="addUserType"
                        name="userType"
                        class="form-control">
                  <option
                          value="0"
                          selected>User</option>
                  <option value="1">Admin</option>
                </select>
              </div>
            </form>
            <div
                 v-show="errorShow"
                 class="toast-top-right"
                 style="margin: 0 0 2%;">
              <div
                   class="toast toast-error"
                   style="opacity: 0.69075;">
                <div
                     class="toast-message"
                     style="padding: 1%; color: white; font-size: 1.5rem;">
                  This user cannot be added: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                    type="button"
                    class="btn btn-md btn-secondary"
                    data-dismiss="modal">No</button>
            <button
                    id="addUserBtn"
                    type="submit"
                    class="btn btn-md btn-danger"
                    @click="addUser">Yes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
         id="editUserInfoModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="editUserInfoLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit User Information</h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form role="form">
              <div class="form-group">
                <label>Name</label>
                <input
                       :value="editUserModalName"
                       type="name"
                       class="form-control"
                       readonly="readonly">
              </div>
              <div class="form-group">
                <label>Student/Work ID</label>
                <input
                       :value="editUserModalSchoolId"
                       type="text"
                       class="form-control"
                       readonly="readonly">
                <input
                       :value="editUserModalId"
                       type="hidden"
                       class="form-control"
                       readonly="readonly">
              </div>
              <div class="form-group">
                <label for="userType">User Type</label>
                <select
                        id="userType"
                        v-model="editUserModalUserType"
                        name="userType"
                        class="form-control">
                  <option value="0">User</option>
                  <option value="1">Admin</option>
                </select>
              </div>
            </form>
            <div
                 v-show="errorShow"
                 class="toast-top-right"
                 style="margin: 0 0 2%;">
              <div
                   class="toast toast-error"
                   style="opacity: 0.69075;">
                <div
                     class="toast-message"
                     style="padding: 1%; color: white; font-size: 1.5rem;">
                  This user's information cannot be modified: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                    type="button"
                    class="btn btn-md btn-secondary"
                    data-dismiss="modal">No</button>
            <button
                    id="editUserInfoBtn"
                    type="submit"
                    class="btn btn-md btn-danger"
                    @click="editUser">Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import Vuetable from "vuetable-2/src/components/Vuetable";
import FilterBar from "./FilterBar.vue";
import VuetablePagination from "./VuetablePaginationDropdownCustom.vue";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import Vue from "vue";
import VueEvents from "vue-events";
Vue.use(VueEvents);

export default {
  name: "UsersInfo",
  components: {
    Vuetable,
    "filter-bar": FilterBar,
    VuetablePagination,
    VuetablePaginationInfo,
    vueevents: VueEvents
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      usersInfo: [],
      formatUsersInfo: {},
      searchInputName: "",
      searchInputId: "",
      searchIsAdmin: false,
      searchResult: [],
      searchResultShow: false,
      fields: [
        {
          name: "No",
          title: "No."
        },
        "Name",
        {
          name: "ID",
          title: "ID"
        },
        "User Type",
        "Edit"
      ],
      editUserModalName: "",
      editUserModalSchoolId: "",
      editUserModalId: "",
      editUserModalUserType: 0,
      tablecss: {
        tableClass:
          "table table-responsive table-striped table-bordered table-hover signed-users-list",
        titleClass: "title-class"
      },
      paginationcss: {
        wrapperClass: "btn-group pull-right",
        icons: {
          prev: "fa fa-chevron-left",
          next: "fa fa-chevron-right"
        },
        linkClass: "btn btn-default",
        dropdownClass: "btn btn-default dropdown-toggle",
        pageClass: "dropdown-menu",
        disabledClass: "btn-disabled"
      },
      sortType: "1",
      currentSortedData: [],
      perPageInput: "10",
      addUserName: "",
      addUserLdapId: "",
      addUserType: 0,
      outFile: "",
      errorMessage: "",
      errorShow: false
    };
  },
  watch: {
    sortType (newVal, oldVal) {
      this.sortArray(newVal);
    },
    perPageInput (newVal, oldVal) {
      this.perPageInput = newVal;
      // console.log('currentSortedData',this.currentSortedData);
      this.formatUsersInfo = this.transform(this.currentSortedData, true, 1);
      this.onPaginationData(this.formatUsersInfo.pagination);
      // this.fetchData();
    }
  },
  mounted () {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
    this.outFile = document.createElement("a");
  },
  methods: {
    editUser () {
      $("#editUserInfoBtn").button("loading");
      const that = this;
      let postURL = "user/" + that.editUserModalId;
      let userRole = parseInt(that.editUserModalUserType);
      this.request
        .post(postURL, {
          role: userRole
        })
        .then(function (response) {
          // window.alert(response);
          that.errorMessage = "";
          that.errorShow = false;
          toastr.success("Successfully edit user.");
          that.fetchData();
          setTimeout(function () {
            $("#editUserInfoModal").modal("hide");
            console.log("user successfully edited");
            $("#editUserInfoBtn").button("reset");
          }, 500);
        })
        .catch(error => {
          //toastr.error(error.response.data.message);
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#editUserInfoBtn").button("reset");
        })
        .finally(function () {
          that.editUserModalName = "";
          that.editUserModalSchoolId = "";
          that.editUserModalId = "";
          that.editUserModalUserType = 0;
          // that.fetchData();
        });
    },
    addUser () {
      $("#addUserBtn").button("loading");
      const that = this;
      let userRole = parseInt(that.addUserType);
      this.request
        .post("user", {
          name: that.addUserName,
          ldap_id: that.addUserLdapId,
          role: userRole
        })
        .then(function (response) {
          // window.alert(response);
          that.errorMessage = "";
          that.errorShow = false;
          toastr.success("Successfully added user.");
          that.fetchData();
          setTimeout(function () {
            $("#addUserModal").modal("hide");
            console.log("user successfully added");
            $("#addUserBtn").button("reset");
          }, 500);
        })
        .catch(error => {
          //toastr.error(error.response.data.message);
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#addUserBtn").button("reset");
        })
        .finally(function () {
          that.addUserName = "";
          that.addUserLdapId = "";
          that.addUserType = 0;
          // that.fetchData();
        });
    },
    sortArray (type) {
      const that = this;
      let sortedArray = [];
      that.currentSortedData = [];
      switch (type) {
        case "0":
          sortedArray = that.usersInfo.sort(that.compare("name", true));
          that.currentSortedData = sortedArray;
          that.formatUsersInfo = that.transform(sortedArray, true, 1);
          break;
        case "1":
          sortedArray = that.usersInfo.sort(that.compare("name", false));
          that.currentSortedData = sortedArray;
          that.formatUsersInfo = that.transform(sortedArray, true, 1);
          break;
        case "2":
          sortedArray = that.usersInfo.sort(that.compare("ldap_id", true));
          that.currentSortedData = sortedArray;
          that.formatUsersInfo = that.transform(sortedArray, true, 1);
          break;
        case "3":
          sortedArray = that.usersInfo.sort(that.compare("ldap_id", false));
          that.currentSortedData = sortedArray;
          that.formatUsersInfo = that.transform(sortedArray, true, 1);
          break;
      }
    },
    compare (property, positive) {
      if (property === "name") {
        if (positive) {
          return function (a, b) {
            let value1 = a.name;
            let value2 = b.name;
            return value1.localeCompare(value2, "zh-Hans-CN");
          };
        } else {
          return function (a, b) {
            let value1 = a.name;
            let value2 = b.name;
            return value2.localeCompare(value1, "zh-Hans-CN");
          };
        }
      } else {
        if (positive) {
          return function (a, b) {
            let value1 = a["ldap_id"];
            let value2 = b["ldap_id"];
            if (value2 > value1) {
              // console.log(value2 + ">" + value1);
              return -1;
            } else if (value2 === value1) {
              return 0;
            } else {
              // console.log(value2 + "<" + value1);
              return 1;
            }
          };
        } else {
          return function (a, b) {
            // console.log(a, b);
            let value1 = a["ldap_id"];
            let value2 = b["ldap_id"];
            if (value2 > value1) {
              // console.log(value2 + ">" + value1);
              return 1;
            } else if (value2 === value1) {
              return 0;
            } else {
              // console.log(value2 + "<" + value1);
              return -1;
            }
          };
        }
      }
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    transform (data, pagination, currentPage) {
      const that = this;
      let transformed = {};
      transformed.data = [];
      let perPage = parseInt(that.perPageInput);
      let startIndex = (currentPage - 1) * perPage;
      let endIndex = currentPage * perPage;
      if (endIndex > data.length) {
        endIndex = data.length;
      }
      for (var i = startIndex; i < endIndex; i++) {
        transformed.data.push({
          No: data[i].id,
          Name: data[i].name,
          ID: data[i].ldap_id,
          "User Type": that.checkRoles(data[i].roles),
          Edit: `<button type="submit" class="btn btn-xs btn-danger"
                           data-toggle="modal" data-target="#editUserInfoModal">Edit</button>`
        });
      }
      if (pagination === true) {
        transformed.pagination = {
          total: data.length,
          per_page: perPage,
          current_page: currentPage,
          last_page: Math.ceil(data.length / perPage),
          from: 1,
          to: Math.ceil(data.length / perPage),
          prev: currentPage - 1,
          next: currentPage + 1
        };
      }
      // console.log(transformed.data);
      return transformed;
    },
    checkRoles (value) {
      if (value.length !== 0) {
        if (value[0] === "Admin") {
          return "Admin";
        } else {
          return "";
        }
      }
      // return value.length === 0 ? "" : value[0];
    },
    onCellClicked (data, field, event) {
      // console.log(data, field, event);
      if (field.name === "Edit") {
        this.fillEditUserInfo(data["No"], data["Name"], data["ID"]);
      }
    },
    onChangePage (page) {
      if (page < 1 || page > this.formatUsersInfo.pagination.last_page) {
        return;
      }
      this.formatUsersInfo = this.transform(this.usersInfo, true, page);
      this.onPaginationData(this.formatUsersInfo.pagination);
    },
    fillEditUserInfo (id, name, ldap_id) {
      this.editUserModalName = "";
      this.editUserModalSchoolId = "";
      this.editUserModalId = "";
      this.editUserModalName = name;
      this.editUserModalSchoolId = ldap_id;
      this.editUserModalId = id;
    },
    fetchData () {
      const that = this;
      this.$emit("showLoading");
      if (this.user) {
        window.request
          .get(`user/`)
          .then(response => {
            that.usersInfo = response.data.users;
            // that.formatUsersInfo = that.transform(that.usersInfo, true);
          })
          .finally(() => {
            that.currentSortedData = that.usersInfo.sort(
              that.compare("name", false)
            );
            // console.log(that.usersInfo);
            that.formatUsersInfo = that.transform(
              that.currentSortedData,
              true,
              1
            );
            // console.log(that.formatUsersInfo);
            that.onPaginationData(that.formatUsersInfo.pagination);
            that.$emit("hideLoading");
          })
          .catch(error => {
            toastr.error(error.response.data.message);
          });
      }
    },
    searchReset () {
      this.searchInputName = "";
      this.searchInputId = "";
      this.searchIsAdmin = false;
      this.searchResult = [];
      this.searchResultShow = false;
    },
    searchSignedUser () {
      // this.searchResult = [];
      let targetArray = [];
      let searchInputNameRegExp = RegExp(this.searchInputName.toLowerCase());
      let searchInputIdRegExp = RegExp(this.searchInputId);
      switch (this.checkSearchInput()) {
        case 0:
          this.searchResult = this.usersInfo;
          break;
        case 1:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
              targetArray.push(this.usersInfo[i]);
            }
          }
          break;
        case 2:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
              targetArray.push(this.usersInfo[i]);
            }
          }
          break;
        case 3:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
              if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
                targetArray.push(this.usersInfo[i]);
              }
            }
          }
          break;
        case 4:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              targetArray.push(this.usersInfo[i]);
            }
          }
          break;
        case 5:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
                targetArray.push(this.usersInfo[i]);
              }
            }
          }
          break;
        case 6:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
                targetArray.push(this.usersInfo[i]);
              }
            }
          }
          break;
        case 7:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
                if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
                  targetArray.push(this.usersInfo[i]);
                }
              }
            }
          }
          break;
      }
      if (targetArray.length === 0) {
        toastr.error("There is no match result!");
      } else {
        this.searchResult = this.transform(targetArray, false, 1);
      }
      // console.log('transformed', this.searchResult);
      this.searchResultShow = true;
    },
    /*inArray(element, array) {
      for (var i = 0; i < array.length; i++) {
        if (element === i.toString()) {
          return true;
        }
      }
      return false;
    },*/
    checkSearchInput () {
      if (this.searchInputName.trim() === "") {
        if (this.searchInputId.trim() === "") {
          if (!this.searchIsAdmin) {
            return 0; // All are empty
          } else {
            return 1; // Only type is filled
          }
        } else {
          if (!this.searchIsAdmin) {
            return 2; // Only Id is filled
          } else {
            return 3; // Id and Type are filled
          }
        }
      } else {
        if (this.searchInputId.trim() === "") {
          if (!this.searchIsAdmin) {
            return 4; // Only Name is filled
          } else {
            return 5; // Name and Type are filled
          }
        } else {
          if (!this.searchIsAdmin) {
            return 6; // ID and Name are filled
          } else {
            return 7; // All are filled
          }
        }
      }
    },
    downloadUserList () {
      //导出按钮
      const that = this;
      let data = [];
      for (let k in that.usersInfo) {
        data.push({
          ID: that.usersInfo[k].id,
          "Name": that.usersInfo[k].name,
          "Student ID": that.usersInfo[k].ldap_id,
          "Student Email": that.usersInfo[k].email,
          "User Type": that.usersInfo[k].roles.length ? that.usersInfo[k].roles.join(", ") : "Student"
        });
      }
      this.downloadExl(data, "User List");
    },
    downloadExl (data, downName) {
      var workbook = XLSX.utils.book_new();

      var ws = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, ws, "Results");
      XLSX.writeFile(workbook, downName + '.xlsx', { type: 'file' });
    },
    s2ab (s) {
      // 字符串转字符流
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    }
  }
};
</script>

<style scope>
.d-block {
  display: block !important;
}
#event_control .btn {
  margin-bottom: 1rem;
  margin-right: 3rem;
}

@media (max-width: 426px) {
  .mobile-hide {
    display: none;
  }
}
@media (min-width: 426px) {
  .mobile-show {
    display: none;
  }
}

#event_control_user {
  padding: 2% 1% 0 10%;
}

#event_control_user_mobile {
  padding: 20px 1% 0 0;
}

.filter-bar {
  margin-bottom: 2rem;
}
</style>
